module.exports = __webpack_public_path__ + "static/media/湿度.83eefa32.svg";